import React, { useEffect, useCallback, useState} from 'react';
import ModRoutes from './ModRoutes.js';
import ConditionedComponent from "components/ConditionedComponent.js"
import {connect} from 'react-redux';
import ParameterBox from '../ParameterBox.js';
import CheckboxParameter from 'components/effects/CheckboxParameter.js';

const SamplerParameters = ({instrument, sampler, color}) => { 
    return (
        <div className="sampler-params">
          <div className="pitch-params">
            <ParameterBox units="%" name="Start" parameter={instrument.loopStartParameter} color={color}/>
            <ParameterBox units="%" name="Len." parameter={instrument.loopLengthParameter} color={color}/>
            <ParameterBox units="cts" name="Detune" parameter={instrument.detuneParameter} color={color} min={-1000} max={1000} root={1}/>
            {sampler ?
             <ParameterBox
               name="Trspe"
               min={-24}
               max={24}
               color={color}
               parameter={sampler.transposeParameter}
               root={1}/> : ''}
            <ParameterBox units="ms" name="Glide" color={color} parameter={instrument.glideParameter}/>
            <ParameterBox name="R.Mix" color={color} parameter={instrument.crossFadeParameter}/>
          </div>
          <ModRoutes
            color={color}
            sequencerEngine={instrument.sequencerEngine}
            width={290}
            parameters={
                [instrument.loopStartParameter,
                 instrument.loopLengthParameter,
                 instrument.detuneParameter,
                 sampler && sampler.transposeParameter,
                 instrument.glideParameter,
                 instrument.crossFadeParameter
                ]}/>
             
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SamplerParameters);
